export { SocialProof } from './SocialProof'
export type { SocialProofProps } from './SocialProof'
